import { nanoid } from "nanoid";

/** Drop-in replacement for crypto.randomUUID() that works on Android WebView */
export const generateId = (): string => nanoid();
